import * as DateFormat from 'date-fns'
import { AggregationType, DELIMITER, DateDescriptors } from './constants'
import * as Types from './types'

const formatDateTimeForES = (d: Date) => {
  let month = '' + (d.getMonth() + 1)
  let day = '' + d.getDate()
  const year = d.getFullYear()

  if (month.length < 2) {
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }
  return `${[year, month, day].join('-')} ${d.toTimeString()}`
}

export const toFilter = (dateRange: string): Types.DateRangeFilter => {
  const parts = dateRange.split(DELIMITER)
  return {
    gte: parts[0],
    lt: parts[1],
  }
}

export const esToNormalDateRange = (dateRange: string): string => {
  let newDateRange = dateRange
  if (newDateRange.indexOf(DateDescriptors.LastMonthEnd) > -1) {
    newDateRange = newDateRange.replace(DateDescriptors.LastMonthEnd,
      formatDateTimeForES(DateFormat.endOfMonth(DateFormat.subMonths(new Date(), 1))))
  }
  if (newDateRange.indexOf(DateDescriptors.LastMonthStart) > -1) {
    newDateRange = newDateRange.replace(DateDescriptors.LastMonthStart,
      formatDateTimeForES(DateFormat.startOfMonth(DateFormat.subMonths(new Date(), 1))))
  }
  if (newDateRange.indexOf(DateDescriptors.LastWeekEnd) > -1) {
    newDateRange = newDateRange.replace(DateDescriptors.LastWeekEnd,
      formatDateTimeForES(DateFormat.endOfWeek(DateFormat.subWeeks(new Date(), 1))))
  }
  if (newDateRange.indexOf(DateDescriptors.LastWeekStart) > -1) {
    newDateRange = newDateRange.replace(DateDescriptors.LastWeekStart,
      formatDateTimeForES(DateFormat.startOfWeek(DateFormat.subWeeks(new Date(), 1))))
  }
  if (newDateRange.indexOf(DateDescriptors.PastDayStart) > -1) {
    newDateRange = newDateRange.replace(DateDescriptors.PastDayStart,
      formatDateTimeForES(DateFormat.startOfDay(DateFormat.subDays(new Date(), 1))))
  }
  if (newDateRange.indexOf(DateDescriptors.OneDayAgo) > -1) {
    newDateRange = newDateRange.replace(DateDescriptors.OneDayAgo,
      formatDateTimeForES(DateFormat.subDays(new Date(), 1)))
  }
  if (newDateRange.indexOf(DateDescriptors.PastMonthStart) > -1) {
    newDateRange = newDateRange.replace(DateDescriptors.PastMonthStart,
      formatDateTimeForES(DateFormat.subDays(new Date(), 30)))
  }
  if (newDateRange.indexOf(DateDescriptors.PastWeekStart) > -1) {
    newDateRange = newDateRange.replace(DateDescriptors.PastWeekStart,
      formatDateTimeForES(DateFormat.subDays(new Date(), 7)))
  }
  if (newDateRange.indexOf(DateDescriptors.PastYearStart) > -1) {
    newDateRange = newDateRange.replace(DateDescriptors.PastMonthStart,
      formatDateTimeForES(DateFormat.subDays(new Date(), 365)))
  }
  if (newDateRange.indexOf(DateDescriptors.TodayStart) > -1) {
    newDateRange = newDateRange.replace(DateDescriptors.TodayStart,
      formatDateTimeForES(DateFormat.startOfDay(new Date())))
  }
  if (newDateRange.indexOf(DateDescriptors.YesterdayEnd) > -1) {
    newDateRange = newDateRange.replace(DateDescriptors.YesterdayEnd,
      formatDateTimeForES(DateFormat.endOfDay(DateFormat.subDays(new Date(), 1))))
  }
  if (newDateRange.indexOf(DateDescriptors.LastMonthWeekStart) > -1) {
    newDateRange = newDateRange.replace(DateDescriptors.LastMonthWeekStart,
      formatDateTimeForES(DateFormat.startOfWeek(DateFormat.subMonths(new Date(), 1))))
  }
  if (newDateRange.indexOf(DateDescriptors.Now) > -1) {
    newDateRange = newDateRange.replace(DateDescriptors.Now,
      formatDateTimeForES((new Date())))
  }
  return newDateRange
}

export const addAggregation = (payload: any, request: Types.AggregationRequest): any => {
  if (request.unique_on) {
    // NOTE: THe literal string 'unique' corresponds to the property on ResponseAggregate
    // This could be done dynamically - but that would take a richer "getAggregation" approach
    return payload.aggregation(
             request.type,
             request.field,
             request.extra,
             request.name,
             (a: any) => a.aggregation(
               AggregationType.cardinality,
               request.unique_on,
               'unique',
             ),
            )
  } else if (request.child) {
    return payload.aggregation(
      request.type,
      request.field,
      request.extra,
      request.name,
      (a: any) => addAggregation(a, {
        ...request.child,
        name: 'child',
      }))
  } else {
    return payload.aggregation(request.type, request.field, request.name)
  }
}

export const getAggregation = (aggregation: Types.ResponseAggregation, key: string): Types.ResponseAggregate => {
  return aggregation.buckets.find((b: Types.ResponseAggregate) => b.key === key)
}

